<template>
	<div
		class="sidebar-cart__additional"
		:class="{
			'sidebar-cart__additional--open': additionalOpen
		}"
	>

		<div
			class="sidebar-cart__additional-title"
			:class="{
				'sidebar-cart__additional-title--empty': !additionalItems.length
			}"
		>
			<div class="sidebar-cart__additional-title-text">
				<a
					class="sidebar-cart__additional-title-link"
					v-html="$t('cart.additionalProducts.title')"
					href=""
					@click.prevent="onAdditionalToggle"
				/>
				<Button
					class="sidebar-cart__additional-title-edit"
					icon="edit"
					text=""
					type="button"
					level="tertiary"
					@click.prevent="onAdditionalEdit"
				/>
			</div>

			<div
				class="sidebar-cart__additional-title-price"
				v-html="$options.filters.madpricecent(additionalItemsPrice, 'short')"
			/>
		</div>
		<ul
			class="sidebar-cart__additional-list"
			ref="additionalitems"
		>
			<li
				class="sidebar-cart__additional-item"
				v-for="item in additionalItems"
				:key="item.id"
			>
				<div
					class="sidebar-cart__additional-item-amount"
					v-html="item.quantity"
				/>
				<div
					class="sidebar-cart__additional-item-name"
					v-html="item.name"
				/>
				<div
					class="sidebar-cart__additional-item-price"
					v-html="$options.filters.madpricecent(item.originalTotal, 'short')"
				/>
			</li>
		</ul>
		<!--
		<Button
			class="sidebar-cart__additional-edit"
			icon="settings"
			text="Stäbchen und Saucen anpassen"
			type="button"
			level="tertiary"
			arrow
			@click.prevent="onAdditionalEdit"
		/>
		-->
	</div>
</template>

<script>
import Button from '@/components/Button';

export default {
	components: {
		Button
	},
	props: {
		additionalOpen: Boolean,
		additionalItems: Array,
		additionalItemsPrice: Number | String,
	},
	methods: {
		onAdditionalToggle() {
			if (this.$refs.additionalitems) {
				if (this.$refs.additionalitems.scrollHeight) {
					this.$refs.additionalitems.addEventListener('transitionend', e => {
						this.$refs.additionalitems.style.maxHeight = '';
					}, { once: true });

					this.$refs.additionalitems.style.maxHeight = `${this.$refs.additionalitems.scrollHeight}px`;
				}
				setTimeout(() => {
					this.$emit('toggle');
				}, 1);
			}
		},
		onAdditionalEdit() {
			this.$emit('edit');
		},
	}
}
</script>
